import React from 'react';
import { dummyStoreInfo } from '../dummyData';
import BannerBgImg from '../../adminAssets/images/templates/banner_background.png';
import StoreImg from '../../adminAssets/images/templates/store_image.png';

const TemplateBanner = ({ websiteData }) => {
    return (
        <div className="container" style={{ marginBottom: '32px', marginTop: '32px' }}>
            <div
                className="text-white d-flex align-items-center position-relative overflow-hidden p-20 p-md-5"
                style={{
                    minHeight: '180px',
                    borderRadius: '12px',
                    backgroundImage: `url(${websiteData?.storeBanner || BannerBgImg})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center'
                }}
            >
                <div className="d-flex align-items-center gap-20 z-1 w-100">
                    <img
                        src={websiteData?.shopLogo || StoreImg}
                        alt="Store Logo"
                        className="rounded-circle object-fit-cover flex-shrink-0"
                        style={{ width: '100px', height: '100px', backgroundColor: '#FFFFFF' }}
                    />

                    <div>
                        <h3 className="mb-3 text-white fw-semibold" style={{ fontSize: '28px', letterSpacing: '0.5px' }}>
                            {websiteData?.shopName || dummyStoreInfo.businessName}
                        </h3>
                        <p className="mb-3 text-14" style={{ color: '#d0d0d0' }}>
                            {websiteData?.storeDescription || "Shop's description"}
                        </p>
                        <div className="d-flex align-items-center gap-2 text-14" style={{ color: '#d0d0d0' }}>
                            <i className="ph-bold ph-link text-16 text-white"></i>
                            <span>linktree.com/shopnamelink</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TemplateBanner;
